import * as types from '../constants/officeRunnerConstants'

export default function lead(state = {}, action) {
  switch (action.type) {
    case types.CREATE_LEAD_SUCCESS:
      return action.lead
    case types.SAVE_LEAD_SECRET_TOKEN:
      return Object.assign({}, state, {
        secret_token: action.token,
      })
    case types.SELECT_POSITION:
      return Object.assign({}, state, {
        secret_token: null, // Reset token if user looks at another position
      })
    default:
        return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/leadReducer.js